import { Theme } from "@mui/material";
import i18n from "locales/i18n";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ScheduleIcon from "@mui/icons-material/Schedule";
import moment from "moment";

import { Attendee, AttendeeStatus } from "../../../types";

const tc = i18n.getFixedT(null, "calendar");
export const statusMeta = (
  status: AttendeeStatus | undefined,
  theme: Theme,
) => {
  switch (status) {
    case "confirmed":
      return {
        label: tc("attendee_status.confirmed"),
        color: theme.palette.success.main,
        Icon: CheckCircleIcon,
      };
    case "declined":
      return {
        label: tc("attendee_status.declined"),
        color: theme.palette.error.main,
        Icon: CancelOutlinedIcon,
      };
    case "reschedule_proposed":
      return {
        label: tc("attendee_status.reschedule_proposed"),
        color: theme.palette.warning.main,
        Icon: ScheduleIcon,
      };
    default:
      return {
        label: tc("attendee_status.invited"),
        color: theme.palette.text.secondary,
        Icon: HelpOutlineIcon,
      };
  }
};

export const proposedText = (a: Attendee): string =>
  a.proposedDate && a.proposedFrom && a.proposedTo
    ? `${moment(a.proposedDate).format("MMM D")} · ${moment(
        a.proposedFrom,
        "HH:mm",
      ).format("h:mm A")} – ${moment(a.proposedTo, "HH:mm").format("h:mm A")}`
    : "";
